export const validateProductPriceTierDerivation = (
  derivationType: "custom" | "flat" | "inherit" | "none" | "percentage",
  derivationValue: number | null,
): boolean => {
  if (["custom", "inherit", "none"].includes(derivationType)) {
    return derivationValue === null;
  }
  return validateCommonDerivation(derivationType, derivationValue);
};

export const validatePriceTierDerivation = (
  derivationType: "base" | "custom" | "flat" | "percentage",
  derivationValue: number | null,
): boolean => {
  if (["base", "custom"].includes(derivationType)) {
    return derivationValue === null;
  }
  return validateCommonDerivation(derivationType, derivationValue);
};

const validateCommonDerivation = (
  derivationType: string,
  derivationValue: number | null,
): boolean => {
  switch (derivationType) {
    case "flat":
      return derivationValue !== null && derivationValue >= 0;

    case "percentage":
      return (
        derivationValue !== null &&
        derivationValue >= 0 &&
        derivationValue <= 100
      );

    default:
      return false;
  }
};
